import {Component, OnInit} from '@angular/core';
import {StoreService} from 'src/app/store.service';
import {UtilitiesService} from '../../core/utilities.service';

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.scss'],
})
export class ReferralComponent implements OnInit {
  bearer: string;
  storeId: string;
  copied = false;
  programLinks: any = [];
  constructor(private svc: StoreService, private utils: UtilitiesService) {}

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.storeId = localStorage.getItem('store_id');

    this.svc
      .getReferralLinks(this.bearer, this.storeId)
      .subscribe((res) => {
        if (res && res['status'] === 'success') {
          this.programLinks = res['data']['link'];
        }
      });
  }

  public copyUrl(url: any): void {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = url;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.copied = true;
    this.utils.notify.showSuccess(
      this.utils.translate('Link has been successfully copied !')
    );
    setTimeout(() => {
      if (this.copied) {
        this.copied = false;
      }
    }, 3000);
  }

  public async shareUrl(url: any): Promise<void> {

    const shareData = {
      url,
    };

    try {
      await navigator.share(shareData);
    } catch (err) {
      console.error({err});
    }
  }
}
